export default function PrimaryButton({
    className = "",
    disabled,
    children,
    ...props
}) {
    return (
        <button
            {...props}
            className={[
                "flex items-center gap-3 border border-transparent text-sm text-white transition px-4 select-none !bg-[#2f2f2f] shadow-sm font-semibold rounded-md  py-2",
                disabled
                    ? "opacity-70 hover:opacity-70 cursor-not-allowed"
                    : "hover:opacity-90",
                className,
            ].join(" ")}
            disabled={disabled}
        >
            {children}
        </button>
    );
}
